import { getExtensibilityNotification, lazyRemoveExtensibilityNotification, lazyUpdatePersistentNotifications, } from 'owa-addins-core';
import { InfoBarMessageColor, InfoBarMessageRank, InfoBarMessageSource, } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
var DISMISS_ACTION_TEXT = 'Dismiss';
export default function createInfoBarMessageViewStateFactory(hostItemIndex, messageId, removeNotificationMessage) {
    return function () {
        var notification = getExtensibilityNotification(messageId);
        if (!notification) {
            return null;
        }
        var dismissAction = getDismissAction(hostItemIndex, messageId, notification, removeNotificationMessage);
        return {
            key: notification.Key,
            source: InfoBarMessageSource.Extensibility,
            rank: getRank(notification.Type),
            messageParts: [notification.Message, '|', dismissAction],
            color: InfoBarMessageColor.Grey,
        };
    };
}
function getDismissAction(hostItemIndex, messageId, notification, removeNotificationMessage) {
    return {
        text: DISMISS_ACTION_TEXT,
        action: function () {
            var extensionId = notification.ExtensionId;
            var isPersistent = notification.Persistent;
            lazyRemoveExtensibilityNotification.import().then(function (removeExtensibilityNotification) {
                removeExtensibilityNotification(messageId);
                if (isPersistent) {
                    lazyUpdatePersistentNotifications
                        .import()
                        .then(function (updatePersistentNotifications) {
                        updatePersistentNotifications(hostItemIndex, extensionId);
                    });
                }
            });
            removeNotificationMessage(messageId);
        },
    };
}
function getRank(type) {
    switch (type) {
        case 0 /* InformationalMessage */:
        case 1 /* ProgressIndicator */:
            return InfoBarMessageRank.Info;
        case 2 /* ErrorMessage */:
            return InfoBarMessageRank.Error;
    }
    return InfoBarMessageRank.Safety;
}
//# sourceMappingURL=createInfoBarMessageViewStateFactory.js.map